var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"iconfont",class:("icon-" + _vm.name),style:(_vm.size ? ("font-size: " + _vm.size + "px; line-height: " + _vm.size + "px;") : '')})}
var staticRenderFns = []

export { render, staticRenderFns }